import { render, staticRenderFns } from "./SuggestionListBlock.vue?vue&type=template&id=34d97c50&scoped=true&"
import script from "./SuggestionListBlock.vue?vue&type=script&lang=js&"
export * from "./SuggestionListBlock.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListBlock.vue?vue&type=style&index=0&id=34d97c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d97c50",
  null
  
)

export default component.exports